/*
  +--------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     质检store
  +--------------------------------------------------------------------------------------
*/

import Vue from 'vue'
// import { qcSchemeGetallApi } from '@/api/qc/indexApi'

const godStore = {
  state: {
    allQcSchemes: []
  },

  mutations: {
    SET_ALL_QC_SCHEMES: (state, list) => {
      state.allQcSchemes = list
    },
  },

  actions: {
  }
}

export default godStore
